module.exports = __webpack_public_path__ + "assets/img/pop-foto-desktop.5678a510.png";